import rougeTheme from './rouge.css';
import bleuTheme from './bleu.css';
import bleuClairTheme from './bleu-clair.css';
import vertTheme from './vert.css';
import vertLegerTheme from './vert-leger.css';
import turquoiseTheme from './turquoise.css';
import orangeTheme from './orange.css';
import indigoTheme from './indigo.css';
import mauveTheme from './mauve.css';
import grisTheme from './gris.css';

export const themes = {
  rouge: rougeTheme,
  bleu: bleuTheme,
  bleuClair: bleuClairTheme,
  vert: vertTheme,
  vertLeger: vertLegerTheme,
  orange: orangeTheme,
  turquoise: turquoiseTheme,
  indigo: indigoTheme,
  mauve: mauveTheme,
  gris: grisTheme,
};

export type SpwTheme = keyof typeof themes;
